<template>
  <v-row>
    <v-dialog max-width="550" v-model="component.dialog" persistent>
      <v-card class="mx-auto" outlined>
        <v-container>
          <v-row>
            <v-card-title> Pesquisar Vendedores </v-card-title>
            <v-spacer></v-spacer>
            <v-icon
              class="mr-2 mb-6"
              @click="
                () => {
                  close();
                }
              "
              >mdi-close</v-icon
            >
          </v-row>
          <v-text-field
            outlined
            label="Pesquisar"
            v-model="search"
            append-icon="mdi-magnify"
          ></v-text-field>
          <v-data-table
            v-if="!isMobile"
            :headers="headers"
            :search="search"
            :items="results"
            hide-default-footer
            no-data-text="Sem registros"
            no-results-text="Nenhum vendedor encontrado"
            :footer-props="{
              'items-per-page-options': [10, 20, 30, -1],
              'items-per-page-text': 'Items por página',
            }"
          >
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon
                color="green darken-3"
                class="ml-3"
                @click="() => { add_seller(item); }"
                >mdi-plus-circle</v-icon
              >
            </template>
          </v-data-table>

          <v-list v-else class="mobile-list">
            <template v-for="(item, index) in results">
              <v-list-item :key="item.id" class="mobile-list-item">
                <v-list-item-content class="py-2">
                  <v-list-item-title class="item-name">
                    {{ item.physicalpeople && item.physicalpeople.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="item-code">Cód: {{ item.id }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn depressed small color="green darken-3" dark class="action-btn" @click="add_seller(item)">
                    <v-icon small>mdi-plus</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-divider :key="`d-${index}`" />
            </template>
            <v-list-item v-if="!results || results.length === 0">
              <v-list-item-content>
                <v-list-item-title class="text-center grey--text">Sem registros</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <v-pagination
            color="success"
            v-model="current"
            :length="total"
            :total-visible="10"
          ></v-pagination>
        </v-container>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { headers } from "./script";
import { GET_ALL_SELLER } from "../../../../store/actions/seller";
import { mapGetters } from "vuex";
export default {
  props: { component: Object },
  data: () => ({
    search: String(),
    headers,
    results: Array(),
    total: 1,
    current: 1,
  }),
  methods: {
    close() {
      this.component.dialog = !this.component.dialog;
    },
    add_seller(item) {
      this.component.refreshSeller(item);
      this.close();
    },
    async getAllSeller(page = 1) {
      await this.$store.dispatch(GET_ALL_SELLER, { page: page, limit: 10 });
    },
  },
  watch: {
    getSeller: function (val) {
      this.results = val.data;
      this.current = val.current_page;
      this.total = val.last_page;
    },
    current: function (val) {
      if (val !== this.getSeller.current_page) {
        this.getAllSeller(val);
      }
    }
  },
  computed: {
    ...mapGetters(["getSeller"]),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  async created() {
    await this.getAllSeller();
  },
};
</script>

<style scoped>
.mobile-list {
  overflow-y: auto;
  max-height: 50vh;
  padding: 0;
}

.mobile-list-item {
  min-height: 52px;
}

.item-name {
  font-size: 13px !important;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.item-code {
  font-size: 11px !important;
}

.action-btn {
  min-width: 32px !important;
  width: 32px !important;
  height: 32px !important;
  padding: 0 !important;
}
</style>